import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

function Footer() {

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="bg-[#0F172A] text-white relative">

      {/* Main Footer */}

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Company */}

          <div>

            <div className="flex items-center gap-3">

              <img
                src="/DWP2.jpeg"
                alt="Digital with Priyanshi"
                className="w-14 h-14 rounded-full"
              />

              <div>

                <h2 className="text-2xl font-bold">
                  Digital with Priyanshi
                </h2>

                <p className="text-blue-300 text-sm">
                  Learn. Create. Innovate.
                </p>

              </div>

            </div>

            <p className="mt-6 text-gray-300 leading-8">
              Empowering students with practical digital skills through
              Web Development, Graphic Design, Digital Marketing,
              Agent AI and Generative AI.
            </p>

          </div>

          {/* Quick Links */}

          <div>

            <h3 className="text-xl font-semibold mb-6">
              Quick Links
            </h3>

            <ul className="space-y-4 text-gray-300">

              <li>
                <a href="#home" className="hover:text-white transition">
                  Home
                </a>
              </li>

              <li>
                <a href="#about" className="hover:text-white transition">
                  About Us
                </a>
              </li>

              <li>
                <a href="#courses" className="hover:text-white transition">
                  Courses
                </a>
              </li>

              <li>
                <a href="#benefits" className="hover:text-white transition">
                  Benefits
                </a>
              </li>

              <li>
                <a href="#contact" className="hover:text-white transition">
                  Contact
                </a>
              </li>

            </ul>

          </div>

          {/* Courses */}

          <div>

            <h3 className="text-xl font-semibold mb-6">
              Our Courses
            </h3>

            <ul className="space-y-4 text-gray-300">

              <li>Web Development</li>
              <li>Graphic Design</li>
              <li>Digital Marketing</li>
              <li>Agent AI</li>
              <li>Generative AI</li>

            </ul>

          </div>

          {/* Contact */}

          <div>

            <h3 className="text-xl font-semibold mb-6">
              Contact
            </h3>

            <div className="space-y-5">

              <div className="flex gap-3">

                <Phone className="text-blue-400" />

                <p className="text-gray-300">
                  +91 8817289144
                </p>

              </div>

              <div className="flex gap-3">

                <Mail className="text-blue-400" />

                <p className="text-gray-300">
                  digitalwithpriyanshi@gmail.com
                </p>

              </div>

              <div className="flex gap-3">

                <MapPin className="text-blue-400" />

                <p className="text-gray-300">
                  Alkapuri Ambe Chowk, B/277, Alkapuri, Ratlam,(M.P.) 457001
                </p>

              </div>

            </div>

            {/* Social */}

            <div className="flex gap-4 mt-8">

              <a
                href="/"
                className="w-11 h-11 rounded-full bg-white/10 flex justify-center items-center hover:bg-blue-600 transition"
              >
                <FaFacebookF />
              </a>

              <a
                href="/"
                className="w-11 h-11 rounded-full bg-white/10 flex justify-center items-center hover:bg-pink-600 transition"
              >
                <FaInstagram />
              </a>

              <a
                href="/"
                className="w-11 h-11 rounded-full bg-white/10 flex justify-center items-center hover:bg-blue-500 transition"
              >
                <FaLinkedinIn />
              </a>

              <a
                href="/"
                className="w-11 h-11 rounded-full bg-white/10 flex justify-center items-center hover:bg-red-600 transition"
              >
                <FaYoutube />
              </a>

            </div>

          </div>

        </div>

      </div>

      {/* Bottom Footer */}

      <div className="border-t border-gray-700">

        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="text-gray-400 text-center">
            © 2026 Digital with Priyanshi. All Rights Reserved.
          </p>

          <button
            onClick={scrollTop}
            className="bg-blue-600 hover:bg-blue-700 w-12 h-12 rounded-full flex justify-center items-center transition"
          >
            <ArrowUp />
          </button>

        </div>

      </div>

    </footer>
  );
}

export default Footer;